import type React from 'react';
import type { BaseAdConfig } from 'interfaces/ads/Ad';
import { FooterAd } from './Styles';
import AdSlotToggle from './AdSlotToggle';

const Footer: React.FC<BaseAdConfig> = ({ id }: BaseAdConfig) => (
  <FooterAd>
    <AdSlotToggle
      placementName='Footer'
      index={id + 1}
      slotId={`Footer${id}`}
    />
  </FooterAd>
);

export default Footer;
